import { CrudPage } from '@/components/CrudPage';
import { Badge } from '@/components/ui';
import { formatDateTime } from '@/lib/format';

interface BotGroup {
  id: string;
  name: string;
  description: string | null;
  enabled: boolean;
  created_at: string;
}

export default function BotGroups() {
  return (
    <CrudPage<BotGroup>
      title="Bot groups"
      description="Organise bots into groups. A client can run as many groups as their plan allows."
      resource="bot_groups"
      path="/bot-groups"
      queryKey="bot-groups"
      searchPlaceholder="Search groups…"
      emptyTitle="No bot groups yet"
      emptyDescription="Groups let you separate bots by team, campaign or brand."
      fields={[
        { name: 'name', label: 'Name', required: true, placeholder: 'ABC Group 1' },
        { name: 'description', label: 'Description' },
      ]}
      columns={[
        {
          key: 'name',
          header: 'Group',
          render: (group) => (
            <span className="font-medium text-ink-900 dark:text-ink-50">{group.name}</span>
          ),
        },
        {
          key: 'description',
          header: 'Description',
          render: (group) => (
            <span className="text-ink-600 dark:text-ink-300">{group.description ?? '—'}</span>
          ),
        },
        {
          key: 'enabled',
          header: 'Status',
          render: (group) => (
            <Badge tone={group.enabled ? 'green' : 'gray'}>
              {group.enabled ? 'Enabled' : 'Disabled'}
            </Badge>
          ),
        },
        {
          key: 'created_at',
          header: 'Created',
          render: (group) => (
            <span className="text-xs text-ink-500">{formatDateTime(group.created_at)}</span>
          ),
        },
      ]}
    />
  );
}
